// The API may return a plain array or a paginated object, so normalise both.
export const toList = (payload: any): any[] => {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.data)) return payload.data
  return []
}

export const getCategoryChannels = (category: any): any[] =>
  toList(category?.channels ?? category?.services)
